import { useAuth } from 'hooks';
import { FunctionComponent, useMemo, useState, useEffect } from 'react';
import PrivatePage from './PrivatePage';
import PageSidebar from 'components/PageSidebar';
import ClientsAndPets from 'components/Insights/ClientsAndPets/ClientsAndPets';
import Dashboard from 'components/Insights/Dashboard/Dashboard';
import { getCategoryData, Categories } from 'components/Insights/Data/InsightStructure';
import Sales from 'components/Insights/Sales/Sales';
import { useLocation } from 'react-router-dom';
import Bookings from 'components/Insights/Bookings/Bookings';
import Marketing from 'components/Insights/Marketing';
import Staff from 'components/Insights/Staff/Staff';
import store from 'store';

export const Insights: FunctionComponent = () => {
    document.title = 'Insights - Cuddles';
    const auth = useAuth();
    const location = useLocation();

    const insightsUrl = `${process.env.REACT_APP_HOST_URL}${process.env.REACT_APP_WEB_BASE_URL}stats?access_token=${auth.token}&marketplace_id=${auth.marketplaceId}`;

    const marketplaceId = store.getState().marketplace.marketplace.id;
    const CategoryData = getCategoryData(marketplaceId);

    const sidebarItems = useMemo(() => {
        return CategoryData.flatMap(category => (category.data[0].visible ? category.data : []));
    }, []);

    const [selectedKey, setSelectedKey] = useState<string>(sidebarItems[0].key);

    useEffect(() => {
        const hash = location.hash.replace('#', '');
        setSelectedKey(hash);
    }, [location]);

    const sidebar = (
        <PageSidebar
            title="Insights"
            items={sidebarItems}
            selectedKey={selectedKey}
            onSelect={setSelectedKey}
        />
    );

    const dashboard = (
        <PrivatePage
            title={`${Categories.DASHBOARD} - Cuddles`}
            pageName="/insights"
            pageSidebar={sidebar}
        >
            <Dashboard
                title={Categories.DASHBOARD}
                insightsUrl={insightsUrl}
            />
        </PrivatePage>
    );

    const clientsAndPets = (
        <PrivatePage
            title={Categories.CLIENTS_AND_PETS}
            pageName="/insights/clients"
            pageSidebar={sidebar}
        >
            <ClientsAndPets
                category={Categories.CLIENTS_AND_PETS}
                title={Categories.CLIENTS_AND_PETS}
            />
        </PrivatePage>
    );

    const sales = (
        <PrivatePage
            title={Categories.SALES}
            pageName="/insights/sales"
            pageSidebar={sidebar}
        >
            <Sales
                category={Categories.SALES}
                title={Categories.SALES}
            />
        </PrivatePage>
    );

    const bookings = (
        <PrivatePage
            title={Categories.BOOKINGS}
            pageName="/insights/bookings"
            pageSidebar={sidebar}
        >
            <Bookings
                category={Categories.BOOKINGS}
                title={Categories.BOOKINGS}
            />
        </PrivatePage>
    );

    const staff = (
        <PrivatePage
            title={Categories.CLIENTS_AND_PETS}
            pageName="/insights/staff"
            pageSidebar={sidebar}
        >
            <Staff
                category={Categories.STAFF}
                title={Categories.STAFF}
            />
        </PrivatePage>
    );

    const marketing = (
        <PrivatePage
            title={Categories.MARKETING}
            pageName="/insights/marketing"
            pageSidebar={sidebar}
        >
            <Marketing
                category={Categories.MARKETING}
                title={Categories.MARKETING}
            />
        </PrivatePage>
    );

    switch (selectedKey) {
        case 'clients-and-pets':
            return clientsAndPets;
        case 'sales':
            return sales;
        case 'bookings':
            return bookings;
        case 'staff':
            return staff;
        case 'marketing':
            return marketing;
        default:
            return dashboard;
    }
};

export default Insights;
